
import axios from '@/utils/axios'

export const getCustomerConversionByMarketClueId = function(marketClueId: number) {
    return axios.get('/market/getCustomerConversionByMarketClueId', { params: { marketClueId } })
}


// 合作伙伴接口
// 合作伙伴审批撤回
export const setMarketCooperationStatusById = function(id: number) {
    return axios.post('/market/setMarketCooperationStatusById', { id })
}

// 合作伙伴结算价列表
export const getProjectAllGroupPriceListBySouCourseTypeId = function(data: { id?: string; souCourseTypeIdList: number[] }) {
    return axios.post('/market/getProjectAllGroupPriceListBySouCourseTypeId', data)
}

// 获取指定项目类型下的项目
export const getProjectAllListBySouCourseTypeId = function(data) {
    return axios.post('/market/getProjectAllListBySouCourseTypeId', data)
}

// 获取上级合作伙伴列表
export const getMarketCooperationPrevLevel = function (data?: { limit?: number; page?: number; name?: string; id?: number }) {
    return axios.post('/market/getMarketCooperationPrevLevel', data)
}

// 合作伙伴查重
export const duplicateCheckMarketCooperation = function(data) {
    return axios.post('/market/duplicateCheckMarketCooperation', data)
}

// 获取论文项目列表
export const getProjectDissertationList = function() {
    return axios.get('/market/getProjectDissertationList')
}

// 新建合作伙伴
export const setMarketCooperation = function(data) {
    return axios.post('/market/setMarketCooperation', data)
}

// 查看合作伙伴
export const getMarketCooperationById = function(params) {
    return axios.get('/market/getMarketCooperationById', { params })
}

// 编辑合作伙伴
export const setMarketCooperationById = function(data) {
    return axios.post('/market/setMarketCooperationById', data)
}

// 获取关联上级对应的佣金信息
export const getPrevMarketCooperationById = function(params) {
    return axios.get('/market/getPrevMarketCooperationById', { params })
}

// 合作伙伴导入
export const importMarketCooperation = function(data) {
    return axios.post('/market/importMarketCooperation', data)
}

// 市场线索二维码报名
export const setMarketClueByQrcode = function(data: {
    name: string;
    phone: string;
    directorUserId: string;
    weChat: string;
    email: string;
    remark?: string;
}) { return axios.post('/market/setMarketClueByQrcode', data) }

// 合作拜访次数对比导出
export const getMarketCooperationContrastExport = function(data: {
    firstTimeStr: string;
    secondTimeStr: string;
    keys?: string;
}) { return axios.post('/market/getMarketCooperationContrastExport', data) }

// 合作伙伴送生数对比导出
export const getMarketCooperationFinanceOrderExport = function(data: {
    firstTimeStr: string;
    secondTimeStr: string;
    keys?: string;
}) { return axios.post('/market/getMarketCooperationFinanceOrderExport', data) }
